import script from "./CacheManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./CacheManagement.vue?vue&type=script&setup=true&lang=js"

import "./CacheManagement.vue?vue&type=style&index=0&id=5a070064&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a070064"]])

export default __exports__